import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Tabs from 'cccisd-tabs';
import Tooltip from 'cccisd-tooltip';
import Loader from 'cccisd-loader';

import IndividualDataTab from './IndividualDataTab';
import AggregateDataTab from './AggregateDataTab';

import {
    queryAllAnswerData,
    computeScoreAverages,
    setAggregateScoreAverages,
    queryAdministeredPlansData,
} from '../../reducers/dashboard/dashboardSlice';
import { queryCareCoordinatorYouthList } from '../../reducers/careCoordinator/careCoordinatorSlice';

const Dashboard = () => {
    const [loading, setLoading] = useState(true);

    // state
    const dispatch = useDispatch();
    const allAnswerData = useSelector(state => state.app.dashboard.allAnswerData);
    const youthList = useSelector(state => state.app.careCoordinator.youthList);
    const selectedYouth = useSelector(state => state.app.dashboard.selectedYouth);
    const startDate = useSelector(state => state.app.dashboard.filters.startDate);
    const endDate = useSelector(state => state.app.dashboard.filters.endDate);
    const planName = useSelector(state => state.app.dashboard.filters.planName);
    const administeredPlansData = useSelector(state => state.app.dashboard.administeredPlansData);

    // dispatch queries to be loaded into state if not already
    useEffect(() => {
        const dispatchQueries = async () => {
            setLoading(true);

            if (allAnswerData === null) {
                await dispatch(queryAllAnswerData());
            }
            if (youthList.length === 0) {
                await dispatch(queryCareCoordinatorYouthList());
            }
            if (!administeredPlansData || Object.keys(administeredPlansData).length === 0) {
                await dispatch(queryAdministeredPlansData());
            }

            setLoading(false);
        };

        dispatchQueries();
    }, [youthList, allAnswerData]);

    // Recompute scoreAverages whenever data, filters, or selected youth change
    useEffect(() => {
        if (!allAnswerData || !youthList.length) return;

        dispatch(
            setAggregateScoreAverages(
                computeScoreAverages(allAnswerData, youthList, { startDate, endDate, planName }, selectedYouth)
            )
        );
    }, [allAnswerData, youthList, startDate, endDate, planName, selectedYouth]);

    const tabList = [
        {
            name: 'individual',
            title: (
                <Tooltip title="Shows scores to each survey item for each individual caregiver and/or youth, grouped by domain.">
                    Individual Data
                </Tooltip>
            ),
            content: <IndividualDataTab />,
        },
        {
            name: 'aggregate',
            title: 'Aggregate Data',
            content: <AggregateDataTab />,
        },
    ];

    if (loading) {
        return <Loader loading />;
    }

    return (
        <div style={{ marginTop: '2rem' }}>
            <Tabs tabList={tabList} />
        </div>
    );
};

export default Dashboard;
